import View from "./view";
import Presenter from "./presenter";
import { ConnectComponent2 } from "util";

const states = [
  {
    name: "app.password-recovery",
    url: "/recuperar-senha/:token",
    views: {
      "content@app": ConnectComponent2(View, Presenter)
    }
  }
];

export { states };



// WEBPACK FOOTER //
// ./src/components/app/password-recovery/index.js